<div class="grid">
  <mat-card class="grid-full" *ngIf='(user().isWOCO.length > 0)'>
    <supports [user]="user()"></supports>
  </mat-card>
  <mat-card class="grid-full" *ngIf='(user().isROCO.length > 0) || (user().isWOCO.length > 0)'>
    <coor-assignments
      [user]="user()"></coor-assignments>
  </mat-card>
  <mat-card class="grid-full" *ngIf='user().isFOLO || user().isROLO || user().isWOLO'>
    <line-assignments
      [user]="user()"></line-assignments>
  </mat-card>
  <app-status-rollup [user]="user()" [summaryInfoSelected]="summaryInfoSelected"
                     *ngIf="summaryInfoSelected && user().isLO"
                     [type]="type" [initTab]="true" (changeIndexInit)="indexChange($event)"
                     [public]="false"></app-status-rollup>
  <mat-card class="grid-full">
    <app-authorized-activities [user]="user()"></app-authorized-activities>
  </mat-card>
  <mat-card class="grid-full">
    <team-assignments [user]="user()"></team-assignments>
  </mat-card>
  <mat-card class="grid-half">
    <fa-icon [icon]="faUserGear" aria-label="UPDATE YOUR PROFILE label"></fa-icon>
    <div class="card-text">
      <h1 class="flex-align-center grid-gap-1"><span
        class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">UPDATE YOUR PROFILE</span></h1>
      <p>Please keep your profile updated with your location, skills and experience, and availability.</p>
      <button aria-label="UPDATE YOUR PROFILE Button" class="usa-button usa-button--secondary" mat-dialog-close
              [routerLink]="'/user'">Open Profile
        <fa-icon [icon]="faChevronRight"
                 aria-label="UPDATE YOUR PROFILE Icon"></fa-icon>
      </button>
    </div>
  </mat-card>
  <mat-card class="grid-half">
    <fa-icon [icon]="faUsers" aria-label="USER ROSTER label"></fa-icon>
    <div class="card-text">
      <h1 class="flex-align-center grid-gap-1"><span
        class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">USER ROSTER</span></h1>
      <p>Explore the roster to identify personnel with the right skills and assign the right team members to your
        next fire assessment.</p>
      <button aria-label="USER ROSTER Button" class="usa-button usa-button--secondary" mat-dialog-close
              [routerLink]="'/roster'">View Roster
        <fa-icon [icon]="faChevronRight"
                 aria-label="USER ROSTER Icon"></fa-icon>
      </button>
    </div>
  </mat-card>
  <mat-card class="grid-half">
    <fa-icon [icon]="faAddressCard" aria-label="MY POSITIONS label"></fa-icon>
    <div class="card-text">
      <h1 class="flex-align-center grid-gap-1"><span
        class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">MY POSITIONS</span></h1>
      <div class="positions">
        @for (role of user().baer_roles; track role) {
          <div class="position">
            <mat-chip class="chip">{{ role.baer_role.text }}</mat-chip>
            <fa-icon [icon]="faLocationDot" aria-label="location"></fa-icon>
            @if (role.baer_role_id == 2) {
              <!-- team member should reflect user data -->
              <span><b>Region:</b> {{ user().region ?? '--' }}</span>
              <span><b>Forest:</b> {{ user().forest_name ?? '--' }}</span>
            } @else {
              <span><b>Region:</b>
                @if (role.location_id == 2) {
                  WO
                } @else {
                  {{ role.region ?? user().region }}
                }
                    </span>
              <span><b>Forest:</b>
                @if (role.location_id == 0) {
                  {{ role.forest_name ?? user().forest_name }}
                } @else {
                  --
                }
                    </span>
            }
          </div>
        }
      </div>
      <p><b>Are you a Coordinator or Line Officer?</b> Please reach out to your regional coordinator, forest unit
        coordinator, or WO coordinator to get a position assigned.</p>
      <button aria-label="MY POSITIONS button" class="usa-button usa-button--secondary" mat-dialog-close
              [routerLink]="'/user'">View All
        Positions
        <fa-icon [icon]="faChevronRight" aria-label="MY POSITIONS icon"></fa-icon>
      </button>
    </div>
  </mat-card>
  <mat-card class="grid-half">
    <fa-icon [icon]="faCircleQuestion" aria-label="USER GUIDES label"></fa-icon>
    <div class="card-text">
      <h1 class="flex-align-center grid-gap-1"><span
        class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">USER GUIDES</span></h1>
      <p>Refer to the User Guides to get detailed instructions on how to navigate the application and its
        different modules.</p>
      <button aria-label="USER GUIDES button" class="usa-button usa-button--secondary" mat-dialog-close
              [routerLink]="'/support'">View Support
        <fa-icon [icon]="faChevronRight"
                 aria-label="USER GUIDES icon"></fa-icon>
      </button>
    </div>
  </mat-card>
</div>
